import React, { useEffect, createElement } from 'react';
import { MartialArtsNearMeHeroInfo } from './martial-arts-near-me/MartialArtsNearMeHeroInfo';
import { MartialArtsNearMeHeroForm } from './martial-arts-near-me/MartialArtsNearMeHeroForm';
import { MartialArtsNearMeBenefits } from './martial-arts-near-me/MartialArtsNearMeBenefits';
import { MartialArtsNearMeWhatYouLearn } from './martial-arts-near-me/MartialArtsNearMeWhatYouLearn';
import { MartialArtsNearMeReviews } from './martial-arts-near-me/MartialArtsNearMeReviews';
import { MartialArtsNearMeScheduleLocation } from './martial-arts-near-me/MartialArtsNearMeScheduleLocation';
import { MartialArtsNearMeFAQHeader } from './martial-arts-near-me/MartialArtsNearMeFAQHeader';
import { MartialArtsNearMeFAQQuestions } from './martial-arts-near-me/MartialArtsNearMeFAQQuestions';
import { MartialArtsNearMeFAQActions } from './martial-arts-near-me/MartialArtsNearMeFAQActions';
import { MartialArtsNearMeRelatedLinks } from './martial-arts-near-me/MartialArtsNearMeRelatedLinks';
import { MartialArtsNearMeFinalCTA } from './martial-arts-near-me/MartialArtsNearMeFinalCTA';
export function MartialArtsNearMe() {
  useEffect(() => {
    document.title = 'Martial Arts Near Me | Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Searching for martial arts near Farmington Hills? Storm Taekwondo provides beginner-friendly classes for kids, adults, and families. Try a free week today.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Searching for martial arts near Farmington Hills? Storm Taekwondo provides beginner-friendly classes for kids, adults, and families. Try a free week today.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2510">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2511">
        <div className="absolute inset-0 opacity-20" data-id="element-2512">
          <img src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=1200&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2513" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2514" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2515">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2516">
            <MartialArtsNearMeHeroInfo data-id="element-2517" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2518">
              <MartialArtsNearMeHeroForm data-id="element-2519" />
            </div>
          </div>
        </div>
      </section>
      <MartialArtsNearMeBenefits data-id="element-2520" />
      <MartialArtsNearMeWhatYouLearn data-id="element-2521" />
      <MartialArtsNearMeReviews data-id="element-2522" />
      <MartialArtsNearMeScheduleLocation data-id="element-2523" />
      <section className="py-24 bg-off-white" data-id="element-2524">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2525">
          <MartialArtsNearMeFAQHeader data-id="element-2526" />
          <MartialArtsNearMeFAQQuestions data-id="element-2527" />
          <MartialArtsNearMeFAQActions data-id="element-2528" />
        </div>
      </section>
      <MartialArtsNearMeRelatedLinks data-id="element-2529" />
      <MartialArtsNearMeFinalCTA data-id="element-2530" />
    </div>;
}